import React from "react";
import { supabase } from "./supabase";
import "./App.css";
import wordmark from "./assets/brand/wordmark.svg";

export default function TrialExpired({ store, onSignOut }) {
    return (
        <div style={{
            minHeight: "100vh", background: "var(--bg)",
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: "24px",
            backgroundImage: "radial-gradient(ellipse at 50% 0%, rgba(50,212,224,0.04) 0%, transparent 60%)",
        }}>
            <div style={{
                background: "var(--surface)", border: "1px solid var(--border)",
                borderRadius: "20px", padding: "40px 36px", width: "100%",
                maxWidth: "440px", textAlign: "center", boxShadow: "var(--shadow-lg)",
            }}>

                {/* Icon */}
                <div style={{
                    width: "64px", height: "64px", borderRadius: "50%",
                    background: "var(--amber-dim)", border: "1px solid rgba(255,179,64,0.3)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "28px", margin: "0 auto 20px",
                }}>
                    ⏳
                </div>

                {/* Brand */}
                <div style={{ marginBottom: "16px" }}>
                    <img
                        src={wordmark}
                        alt="SuqPOS"
                        style={{ height: "26px", width: "auto" }}
                    />
                </div>

                <h2 style={{
                    fontSize: "22px", fontWeight: 700, color: "var(--text)",
                    marginBottom: "8px", letterSpacing: "-0.4px",
                }}>
                    Your access has expired
                </h2>

                <p style={{ fontSize: "14px", color: "var(--text3)", marginBottom: "8px", lineHeight: 1.6 }}>
                    Your subscription for{" "}
                    <strong style={{ color: "var(--text)" }}>{store?.name ?? "your store"}</strong>{" "}
                    is not currently active.
                </p>

                <p style={{ fontSize: "13px", color: "var(--text3)", marginBottom: "20px", lineHeight: 1.6 }}>
                    To continue using SuqPOS, make a payment using the details below,
                    then send us your payment receipt to reactivate your account.
                    Your data is safe and will be restored immediately upon confirmation.
                </p>

                {/* Payment details */}
                <div style={{
                    background: "var(--elevated)", border: "1px solid var(--border)",
                    borderRadius: "var(--radius-lg)", padding: "16px", marginBottom: "16px",
                    textAlign: "left",
                }}>
                    <p style={{ fontSize: "11px", fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: "12px" }}>
                        Payment details
                    </p>
                    {[
                        { icon: "🏦", label: "Bank transfer", value: "[BANK_DETAILS_PLACEHOLDER]" },
                        { icon: "📲", label: "Telebirr", value: "[TELEBIRR_NUMBER_PLACEHOLDER]" },
                    ].map((c) => (
                        <div key={c.label} style={{
                            display: "flex", alignItems: "center", gap: "10px",
                            padding: "8px 0", borderBottom: "1px solid var(--border)", fontSize: "13px",
                        }}>
                            <span>{c.icon}</span>
                            <span style={{ color: "var(--text3)" }}>{c.label}</span>
                            <span style={{ color: "var(--cyan)", marginLeft: "auto", textAlign: "right" }}>{c.value}</span>
                        </div>
                    ))}
                </div>

                {/* Contact options */}
                <div style={{
                    background: "var(--elevated)", border: "1px solid var(--border)",
                    borderRadius: "var(--radius-lg)", padding: "16px", marginBottom: "24px",
                    textAlign: "left",
                }}>
                    <p style={{ fontSize: "11px", fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: "12px" }}>
                        Send your payment receipt to
                    </p>
                    {[
                        { icon: "📧", label: "Email", value: "support@suqpos.com" },
                        { icon: "📱", label: "Telegram", value: "@suqpos" },
                    ].map((c) => (
                        <div key={c.label} style={{
                            display: "flex", alignItems: "center", gap: "10px",
                            padding: "8px 0", borderBottom: "1px solid var(--border)", fontSize: "13px",
                        }}>
                            <span>{c.icon}</span>
                            <span style={{ color: "var(--text3)" }}>{c.label}</span>
                            <span style={{ color: "var(--cyan)", marginLeft: "auto" }}>{c.value}</span>
                        </div>
                    ))}
                </div>

                <button
                    onClick={async () => {
                        await supabase.auth.signOut();
                        onSignOut();
                    }}
                    style={{
                        width: "100%", height: "44px",
                        background: "transparent", border: "1px solid var(--border)",
                        borderRadius: "var(--radius-lg)", color: "var(--text3)",
                        fontSize: "14px", fontFamily: "var(--font)", cursor: "pointer",
                        transition: "all 0.15s",
                    }}
                >
                    Sign out
                </button>

            </div>
        </div>
    );
}